/* 2026-06-16 final PDP sticky stack guard. */
(() => {
  const styleId = 'dominator-sticky-stack-final-guard';
  const css = "/* 2026-06-16 final PDP sticky stack guard. */\n.template-product .site-header.is-scrolled {\n  background: #050506 !important;\n  background-color: #050506 !important;\n  color: #fff !important;\n}\n\n.template-product .site-header.is-scrolled .site-header__inner {\n  min-height: 42px !important;\n  height: 42px !important;\n  max-height: 42px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.template-product .pdp-anchor-nav {\n  top: var(--sticky-header-offset, 42px) !important;\n  height: 20px !important;\n  min-height: 20px !important;\n  max-height: 20px !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border-top: 0 !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.14) !important;\n  background: #050506 !important;\n  box-shadow: none !important;\n  overflow-y: hidden !important;\n}\n\n.template-product .pdp-anchor-nav a {\n  height: 18px !important;\n  min-height: 18px !important;\n  max-height: 18px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  border-radius: 3px !important;\n  line-height: 1 !important;\n}\n\n.template-product .pdp-anchor-nav a.is-active,\n.template-product .pdp-anchor-nav a[aria-current=\"true\"] {\n  border-color: #006cff !important;\n  background: #006cff !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.template-product #help-me-choose,\n.template-product #product-compare,\n.template-product #inspect,\n.template-product #social-proof,\n.template-product #reviews,\n.template-product #questions {\n  scroll-margin-top: calc(var(--sticky-header-offset, 42px) + 24px) !important;\n}\n\n@media (max-width: 720px) {\n  .template-product .site-header.is-scrolled .site-header__inner {\n    min-height: 42px !important;\n    height: 42px !important;\n    max-height: 42px !important;\n    padding-left: 18px !important;\n    padding-right: 18px !important;\n  }\n\n  .template-product .pdp-anchor-nav {\n    top: var(--sticky-header-offset, 42px) !important;\n    height: 20px !important;\n    min-height: 20px !important;\n    max-height: 20px !important;\n    grid-auto-columns: minmax(78px, 1fr) !important;\n    gap: 4px !important;\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n    overflow-x: auto !important;\n    scrollbar-width: none !important;\n  }\n\n  .template-product .pdp-anchor-nav::-webkit-scrollbar {\n    display: none !important;\n  }\n\n  .template-product .pdp-anchor-nav a {\n    height: 18px !important;\n    min-height: 18px !important;\n    max-height: 18px !important;\n    padding-left: 6px !important;\n    padding-right: 6px !important;\n    font-size: 8px !important;\n  }\n}\n";
  const upsertStyle = () => {
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = css;
  };
  const syncOffset = () => {
    const header = document.querySelector('[data-site-header]');
    const inner = header?.querySelector('.site-header__inner');
    if (!header || !inner) return;
    document.documentElement.style.setProperty('--sticky-header-offset', Math.ceil(inner.getBoundingClientRect().height) + 'px');
  };
  upsertStyle();
  requestAnimationFrame(syncOffset);
  window.addEventListener('scroll', () => requestAnimationFrame(syncOffset), { passive: true });
  window.addEventListener('resize', () => requestAnimationFrame(syncOffset));
})();


(() => {
  const styleId = 'dominator-sticky-stack-usable-20260616';
  const css = `
    .template-product .pdp-anchor-nav {
      height: 36px !important;
      min-height: 36px !important;
      max-height: 36px !important;
      gap: 8px !important;
      padding-top: 3px !important;
      padding-bottom: 3px !important;
    }
    .template-product .pdp-anchor-nav a {
      height: 30px !important;
      min-height: 30px !important;
      max-height: 30px !important;
      padding: 0 12px !important;
      border-radius: 5px !important;
      font-size: 10px !important;
    }
    @media (max-width: 720px) {
      .template-product .pdp-anchor-nav {
        height: 32px !important;
        min-height: 32px !important;
        max-height: 32px !important;
        grid-auto-columns: minmax(94px, 1fr) !important;
        gap: 6px !important;
        padding: 2px 8px !important;
      }
      .template-product .pdp-anchor-nav a {
        height: 28px !important;
        min-height: 28px !important;
        max-height: 28px !important;
        padding: 0 8px !important;
        font-size: 9px !important;
      }
    }
  `;
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }
  style.textContent = css;
})();

(() => {
  const styleId = 'dominator-sticky-stack-readable-20260618';
  const css = "\n    .template-product .pdp-anchor-nav {\n      height: 42px !important;\n      min-height: 42px !important;\n      max-height: 42px !important;\n      gap: 8px !important;\n      padding-top: 4px !important;\n      padding-bottom: 4px !important;\n      overflow-x: auto !important;\n      scrollbar-width: thin !important;\n    }\n    .template-product .pdp-anchor-nav a {\n      height: 34px !important;\n      min-height: 34px !important;\n      max-height: 34px !important;\n      padding: 0 14px !important;\n      border-radius: 5px !important;\n      font-size: 11px !important;\n      line-height: 1 !important;\n    }\n    @media (max-width: 720px) {\n      .template-product .pdp-anchor-nav {\n        height: 38px !important;\n        min-height: 38px !important;\n        max-height: 38px !important;\n        grid-auto-columns: minmax(104px, 1fr) !important;\n        gap: 6px !important;\n        padding: 3px 8px !important;\n      }\n      .template-product .pdp-anchor-nav a {\n        height: 32px !important;\n        min-height: 32px !important;\n        max-height: 32px !important;\n        padding: 0 10px !important;\n        font-size: 10px !important;\n      }\n    }\n  ";
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement('style');
    style.id = styleId;
    document.head.appendChild(style);
  }
  style.textContent = css;
})();
